var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Title_Base',{attrs:{"icon":_vm.config.icon,"title":_vm.config.text}})}
var staticRenderFns = []

export { render, staticRenderFns }